
"use client";
import { useState, useMemo } from "react";
import { HeroHeader } from "@/components/HeroHeader/HeroHeader";
import { Layout } from "@/components/Layout/Layout";
import { MediaCard } from "@/components/MediaCard/MediaCard";
import HTMLReactParser from "html-react-parser";
import { getImageSrc } from "@/app/utils/getImageSrc";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import dayjs from "dayjs";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function Wrapper({ pageData, media = [] }) {
	const years = useMemo(() => {
		let years = media.map((media) => media.year);
		years.sort(function (a, b) {
			return b - a;
		});
		years = [...new Set(years)];
		return years;
	}, [media]);

	const [active, setActive] = useState(() => {
		let years = media.map((media) => media.year);
		years.sort(function (a, b) {
			return b - a;
		});
		years = [...new Set(years)];
		return years[0];
	});

	const filteredMedia = useMemo(() => {
		return active !== undefined ? media.filter((media) => media.year === active) : [];
	}, [active, media]);

	return (
		<Layout lightHeader={false}>
			<HeroHeader heading={HTMLReactParser(pageData.banner.title)} subHeading={HTMLReactParser(pageData.banner.text)} />
			<section>
				<div className="flex hp-container text-[14px] lg:text-[20px] text-text items-center justify-between">
					<div className="custom_prev bg-white flex justify-center items-center rounded-[26.35px] pr-5 py-3 cursor-pointer">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="text-primary w-6 h-6">
							<path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
						</svg>
					</div>

					{years.length > 0 && active !== undefined ? (
						<Swiper slidesPerView={6} centeredSlides={false} loop={false} modules={[Navigation]} breakpoints={{ 0: { slidesPerView: 3, }, 1024: { spaceBetween: 0, slidesPerView: 5, }, 1280: { spaceBetween: 0, slidesPerView: 6, }, }} navigation={{ nextEl: ".custom_next", prevEl: ".custom_prev", }} className="w-full">
							{years.map((year, key) => {
								return (
									<SwiperSlide key={key}>
										<div className={`py-2 border-b-2 cursor-pointer flex justify-center ${active == year ? "border-primary text-primary font-medium" : "border-[#E9E9E9] text-text font-normal"}`} onClick={() => { setActive(year); }}>
											<h6>{year}</h6>
										</div>
									</SwiperSlide>
								);
							})}
						</Swiper>
					) : (
						<></>
					)}

					<div className="custom_next bg-white flex justify-center items-center rounded-[26.35px] pl-5 py-3 cursor-pointer">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="text-primary w-6 h-6">
							<path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
						</svg>
					</div>
				</div>
			</section>

			<section className="py-8 lg:py-16">
				<div className="hp-container w-full grid grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-2 gap-y-4 lg:gap-8 items-center">
					{filteredMedia.length > 0 ? (
						filteredMedia?.map((item, key) => {
							return (<MediaCard image={getImageSrc(item.image.url)} title={item.title} date={dayjs(item.publishDate).format("D MMM YYYY")} link={item.sourceLink} key={key} />);
						})
					) : (
						<div className="flex justify-center">
							<h5>No media for selected year</h5>
						</div>
					)}
				</div>
			</section>
		</Layout>
	);
}
